var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModeHeating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.703 14.625V18H8.297v-3.375h1.406zm3.772-2.145l2.386 2.387-.994.994-2.387-2.386.995-.995zm-8.95 0l.994.994-2.386 2.387-.994-.994 2.386-2.387zM9 4.781c2.326 0 4.219 1.893 4.219 4.219 0 2.326-1.893 4.219-4.219 4.219-2.326 0-4.219-1.893-4.219-4.219 0-2.326 1.893-4.219 4.219-4.219zm0 1.407C7.45 6.188 6.187 7.449 6.187 9c0 1.55 1.262 2.813 2.813 2.813 1.55 0 2.813-1.262 2.813-2.813 0-1.55-1.262-2.813-2.813-2.813zM3.375 8.296v1.406H0V8.297h3.375zm14.625 0v1.406h-3.375V8.297H18zm-3.133-6.158l.994.994-2.386 2.387-.995-.995 2.387-2.386zm-11.734 0L5.52 4.525l-.995.994L2.14 3.133l.994-.994zM9.703 0v3.375H8.297V0h1.406z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeHeating);
export default __webpack_public_path__ + "static/media/mode-heating.165e059df469e7e17c9043f81ddec5b4.svg";
export { ForwardRef as ReactComponent };